import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ScrapEntry, ScrapEntryCreate, ScrapEntryFilter } from '../data/scrapEntry';

export function createScrapEntryService(client: AxiosInstance) {
  return createCrudService<ScrapEntry, ScrapEntryCreate, ScrapEntryFilter>(
    client,
    '/manufacturing/ScrapEntry',
    'id',
  );
}

export type ScrapEntryService = CrudService<ScrapEntry, ScrapEntryCreate, ScrapEntryFilter>;
